import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/siteData";

export default function ForbiddenPage() {
  return (
    <>
      <Helmet>
        <title>403 - Adgang nægtet | NF-Polering</title>
        <meta name="description" content="Du har ikke adgang til denne side hos NF-Polering." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-[70vh] bg-slate-900 text-white flex items-center justify-center py-20 px-4">
        <div className="max-w-xl w-full text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-amber-500/20 text-amber-400 text-3xl font-black border border-amber-500/40">
            403
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            Adgang Nægtet (403 Forbidden)
          </h1>

          <p className="text-slate-300 text-base leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne ressource på NF-Polering. Benyt venligst navigationen nedenfor til at komme sikkert videre.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-sm shadow-md transition-colors"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til Forsiden</span>
            </Link>

            <Link
              to="/vinduespudsning"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-colors"
            >
              <i className="fa-solid fa-sparkles text-cyan-400" aria-hidden="true" />
              <span>Vinduespolering</span>
            </Link>
          </div>

          <div className="pt-8 border-t border-slate-800 text-xs text-slate-400">
            Kontakt support på{" "}
            <a href={`mailto:${COMPANY_INFO.email}`} className="font-medium text-cyan-400 hover:underline whitespace-nowrap">
              {COMPANY_INFO.email}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
